// Mock data for Unified Power Private Limited

export const companyData = {
  name: "Unified Power Private Limited",
  tagline: "Excellence in Power Plant Engineering",
  established: "1988",
  formerName: "Power Builders",
  website: "www.unifiedpower.online",
  email: "info@unifiedpower.online",
  phones: ["+91 9540504248"],
  
  about: "Unified Power Private Limited (UPPL) was established in 1988 and was formerly known as Power Builders. UPPL is in the business of erection, commissioning, and maintenance, including capital overhaul, renovation, and modernization of various power generating units up to 500 MW rating. Their work involves steam turbines & auxiliaries, generators & auxiliaries, high-pressure boilers & auxiliaries, rotary machines, ESP (Electrostatic Precipitators) etc., in various thermal power stations spread across India.",
  
  vision: "To increase penetration into developing markets and be the number 1 company in the power sector, believing in business excellence through sustainable and equitable development.",
  
  mission: "To cultivate a culture of high integrity and perpetual pursuit for excellence, working in an environment-friendly manner. Time-bound programs and global quality standards are our USP.",
  
  priorities: [
    "Global Quality Standards",
    "Timely delivery of projects",
    "'Zero' tolerance on safety",
    "Innovation"
  ]
};

export const services = [
  {
    id: 1,
    title: "Erection & Commissioning",
    description: "Expert erection and commissioning of power generating units up to 500 MW rating, including turbines, generators, and auxiliaries.",
    icon: "Settings"
  },
  {
    id: 2,
    title: "Capital Overhaul",
    description: "Comprehensive capital overhaul services for steam turbines, generators, boilers, and rotary machines to ensure optimal performance.",
    icon: "Wrench"
  },
  {
    id: 3,
    title: "Renovation & Modernization",
    description: "Upgradation and modernization of existing power plant equipment and systems to enhance efficiency and extend operational life.",
    icon: "RefreshCw"
  },
  {
    id: 4,
    title: "ESP Systems",
    description: "Specialized erection, commissioning, and renovation of Electrostatic Precipitators (ESP) for thermal power stations.",
    icon: "Zap"
  },
  {
    id: 5,
    title: "Boiler Pressure Parts",
    description: "Installation and overhauling of boiler pressure parts, critical piping, and auxiliaries for high-pressure systems.",
    icon: "Flame"
  },
  {
    id: 6,
    title: "Rotary Machinery",
    description: "Erection and commissioning of rotary machinery including bowl mills, ID/FD/PA fans, and air preheaters.",
    icon: "Cog"
  },
  {
    id: 7,
    title: "Switch Yard Installation",
    description: "Erection and commissioning of HT/LT panels and switch yards up to 220 KV for power distribution systems.",
    icon: "Plug"
  },
  {
    id: 8,
    title: "Transmission Systems",
    description: "Construction of large substations, transmission towers, and lines for reliable power transmission infrastructure.",
    icon: "Radio"
  }
];

export const projects = [
  {
    id: 1,
    title: "Manufacturing Activities of Power Transformer",
    client: "Transformer Plant, BHEL Jhansi",
    capacity: "Manufacturing",
    description: "Works Contract of Manufacturing Activities of Power Transformer Using In-House Facilities at BHEL Jhansi."
  },
  {
    id: 2,
    title: "ESP Renovation at NTPC Singrauli",
    client: "NTPC, Singrauli STPS",
    capacity: "500 MW",
    description: "R&M of ESP Unit-6 & 7 at NTPC Singrauli Super Thermal Power Station."
  },
  {
    id: 3,
    title: "TG Maintenance at Bokaro Thermal",
    client: "Bokaro Thermal Power Station",
    capacity: "500 MW",
    description: "Annual Rate Contract for maintenance works of Turbo-Generator and associated equipment."
  },
  {
    id: 4,
    title: "ESP Upgradation at NALCO",
    client: "NALCO - Damanjodi",
    capacity: "3x200 TPH",
    description: "Upgradation, Renovation & Modernisation of existing ESPs at NALCO-DAMANJODI SPP for Units 1, 2 & 3."
  },
  {
    id: 5,
    title: "ESP Retrofitting at Obra TPS",
    client: "UPRVUNL, Obra TPS",
    capacity: "200 MW",
    description: "Renovation & Retrofitting of ESP for Unit No. 13 at Obra Thermal Power Station."
  },
  {
    id: 6,
    title: "ESP & ID Fans Installation at Harduaganj",
    client: "Harduaganj, Aligarh",
    capacity: "110 MW",
    description: "ETC of ESP & 2 Nos ID Fans at Unit-7, Harduaganj Thermal Power Station."
  },
  {
    id: 7,
    title: "ESP Installation at Parichha TPP",
    client: "Parichha TPP, Jhansi",
    capacity: "110 MW",
    description: "ETC of ESP at Unit-2, Parichha Thermal Power Plant."
  },
  {
    id: 8,
    title: "STG Installation at KBUNL Muzaffarpur",
    client: "KBUNL/NTPC, Muzaffarpur",
    capacity: "195 MW",
    description: "Erection, Testing and Commissioning of Steam Turbo-Generator at Unit-2."
  },
  {
    id: 9,
    title: "Boiler Overhauling at Parichha TPP",
    client: "Parichha TPP, Jhansi",
    capacity: "110 MW",
    description: "R&M/Major Overhauling of Boiler Pressure Parts and Auxiliaries at Unit-2."
  },
  {
    id: 10,
    title: "Boiler & Rotary Parts Overhauling at Obra",
    client: "Obra TPS",
    capacity: "200 MW",
    description: "R&M and Dismantling/Overhauling Work of Boiler Items and Rotary Parts at Unit-10 & 11."
  },
  {
    id: 11,
    title: "Boiler & Auxiliaries R&M at Obra",
    client: "Obra TPS",
    capacity: "200 MW",
    description: "R&M of Boiler and Auxiliaries at Unit-12, Obra Thermal Power Station."
  },
  {
    id: 12,
    title: "Capital Overhaul of Boiler",
    client: "Koderma TPS, DVC",
    capacity: "500 MW",
    description: "Capital Overhauling of Boiler and Aux at Unit 2, 500MW at Koderma TPS, DVC."
  }
];

// Clients with logos (uploaded)
export const clientsWithLogos = [
  { name: "Bharat Heavy Electricals Limited", logo: "/logos/bhel.png" },
  { name: "National Thermal Power Corporation Limited", logo: "/logos/ntpc.avif" },
  { name: "Nuclear Power Corporation of India Limited", logo: "/logos/npcil.png" },
  { name: "Punjab State Power Corporation Limited", logo: "/logos/pspcl.png" }
];

// Clients without logos (scrolling marquee)
export const clientsWithoutLogos = [
  "Uttar Pradesh Rajya Vidyut Utpadan Nigam Limited",
  "Rajasthan Atomic Power Station",
  "Tamil Nadu State Power Corporation Limited",
  "Bokaro Steel Plant",
  "Maharashtra State Electricity Board",
  "Haryana State Electricity Board",
  "Atomic Power Station, Narora",
  "Alstom Projects India Limited",
  "Aravali Power Company Private Limited",
  "Indraprastha Power Generation Company Ltd.",
  "Triveni Turbine Limited",
  "Northern Power Corporation Limited",
  "Damodar Valley Power Corporation Limited",
  "Gujarat State Electricity Corporation Limited"
];

export const certifications = [
  {
    id: 1,
    title: "ISO 9001:2008 Certified",
    description: "Certified for Quality Management Systems, ensuring consistent quality in all our services.",
    icon: "Award"
  },
  {
    id: 2,
    title: "Global Quality Standards",
    description: "Committed to maintaining international quality standards in all project deliveries.",
    icon: "CheckCircle"
  },
  {
    id: 3,
    title: "Safety Excellence",
    description: "Zero tolerance policy on safety with dedicated safety officers and protocols.",
    icon: "Shield"
  },
  {
    id: 4,
    title: "Timely Delivery",
    description: "Track record of completing projects within stipulated timelines with precision.",
    icon: "Clock"
  }
];

export const equipment = [
  { name: "Hydra Crane (12T & 14T)", quantity: 10, icon: "Truck" },
  { name: "Tractor With Trailer", quantity: 4, icon: "Truck" },
  { name: "Electric Winch Machine (2T-10T)", quantity: 20, icon: "Anchor" },
  { name: "Chain Pulley Blocks", quantity: 500, icon: "Link" },
  { name: "Max Puller", quantity: 80, icon: "Move" },
  { name: "Hydraulic Jack (50T-150T)", quantity: 25, icon: "ArrowUp" },
  { name: "Welding Rectifier", quantity: 300, icon: "Zap" },
  { name: "Welding Transformer", quantity: 100, icon: "Zap" },
  { name: "Grinders", quantity: 250, icon: "Disc" },
  { name: "Drill Machine", quantity: 60, icon: "Drill" },
  { name: "Measuring Instruments", quantity: 200, icon: "Ruler" },
  { name: "Material Handling Tools", quantity: 300, icon: "Package" }
];

export const leadership = [
  {
    name: "S.K. UPPLA",
    position: "General Manager - Corporate",
    role: "Board of Directors"
  },
  {
    name: "S.A. MUZAFAR",
    position: "General Manager - Project",
    role: "Board of Directors"
  }
];
